import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';
import provideHooks from 'redial/lib/provideHooks';
import { find as findPRU } from '../../../redux/modules/parcelReceptacleUsers';
import { find as findCountries } from '../../../redux/modules/countries';
import { find as findServices } from '../../../redux/modules/services';
import { find as findReceptacleTypes } from '../../../redux/modules/receptacleTypes';

const ReceptacleDashboardLoadable = loadable(() => import('./ReceptacleDashboard'), {
  fallback: <LoadingComponent />,
});

const ReceptacleDashboard = (prop: any) => <ReceptacleDashboardLoadable {...prop} />;

export default provideHooks({
  fetch: async ({ store: { dispatch, getState } }: any) => {
    const promises = [];
    const state = getState();

    if (!state.countries.result.allCountries) {
      promises.push(
        dispatch(
          findCountries('allCountries', {
            query: {
              $paginate: false,
            },
          })
        ).catch(() => null)
      );
    }

    if (!state.receptacleTypes.result.allReceptacleTypes) {
      promises.push(
        dispatch(
          findReceptacleTypes('allReceptacleTypes', {
            query: {
              $paginate: false,
            },
          })
        ).catch(() => null)
      );
    }

    if (!state.services.result.allActiveServices) {
      promises.push(
        dispatch(
          findServices('allActiveServices', {
            query: {
              $paginate: false,
              active: 1,
            },
          })
        ).catch(() => null)
      );
    }

    promises.push(
      dispatch(
        findPRU('prusForReceptacles', {
          query: {
            $paginate: false,
            include: ['User', 'Parcel', 'Unitizer'],
            'unitizer.status': ['created'],
          },
        })
      )
    );

    await Promise.all(promises);
  },
})(ReceptacleDashboard);
